/* eslint-disable no-console */
import { takeLatest, put } from 'redux-saga/effects';
import fileDownload from 'js-file-download';
import * as TypeActions from '../store/programacaoDiariaDia/actionsTypes';
import BaseService from '../services/BaseService';
import * as ToastTypeActions from '../store/toast/actionsTypes';
import * as LoaderTypeActions from '../store/loader/actionsTypes';

function* findById({ id }) {
  try {
    yield put({ type: LoaderTypeActions.LOADER_SHOW });
    const response = yield BaseService.get({ url: `programacao-diaria-dia/${id}` });

    yield put({
      type: TypeActions.PROGRAMACAO_DIARIA_DIA_FIND_BY_ID_SUCCESS,
      data: response.data,
    });
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
  } catch (error) {
    yield console.log(error);
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_ERROR,
      message: 'Erro ao carregar a programação do dia!',
    });
  }
}

function* save({ data, callback }) {
  try {
    yield put({ type: LoaderTypeActions.LOADER_SHOW });
    const response = yield BaseService.post({ url: 'programacao-diaria-dia', data });
    yield put({
      type: TypeActions.SAVE_PROGRAMACAO_DIARIA_DIA_SUCCESS,
      data: response.data,
    });

    if (callback) yield callback(true);
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_SUCCESS,
      message: 'Programação do dia salva com sucesso!',
    });
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
  } catch (error) {
    let message = 'Erro ao salvar a programação do dia!';
    if (error.response && error.response.status === 409) {
      message = error.response.data.mensagem || message;
    }
    if (callback) yield callback(false);

    yield put({ type: LoaderTypeActions.LOADER_HIDE });
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_ERROR,
      message,
    });
  }
}

function* update({ data, callback }) {
  try {
    yield put({ type: LoaderTypeActions.LOADER_SHOW });
    const response = yield BaseService.put({ url: `programacao-diaria-dia/${data.id}`, data });
    yield put({
      type: TypeActions.UPDATE_PROGRAMACAO_DIARIA_DIA_SUCCESS,
      data: response.data,
    });

    if (callback) yield callback(true);
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_SUCCESS,
      message: 'Programação do dia atualizada com sucesso!',
    });
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
  } catch (error) {
    let message = 'Erro ao atualizar a programação do dia!';
    if (error.response && error.response.status === 409) {
      message = error.response.data.mensagem || message;
    }
    if (callback) yield callback(false);

    yield put({ type: LoaderTypeActions.LOADER_HIDE });
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_ERROR,
      message,
    });
  }
}

function* exportProgramacaoDiariaDia({ filter, callbackAfterSave }) {
  try {
    yield put({ type: LoaderTypeActions.LOADER_SHOW });
    const response = yield BaseService.execute({
      url: 'programacao-diaria-dia/export',
      data: filter,
      method: 'POST',
      options: {
        responseType: 'blob',
      },
    });
    yield fileDownload(response.data, 'Relatório Programação Diária.xlsx');
    if (callbackAfterSave) yield callbackAfterSave(response.data);
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_SUCCESS,
      message: 'Relatório gerado com sucesso!',
    });
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
  } catch (error) {
    yield console.log(error);
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_ERROR,
      message: 'Erro ao exportar o relatório!',
    });
  }
}

function* watchProgramacaoDiariaDia() {
  yield takeLatest(TypeActions.PROGRAMACAO_DIARIA_DIA_FIND_BY_ID, findById);
  yield takeLatest(TypeActions.SAVE_PROGRAMACAO_DIARIA_DIA, save);
  yield takeLatest(TypeActions.UPDATE_PROGRAMACAO_DIARIA_DIA, update);
  yield takeLatest(TypeActions.PROGRAMACAO_DIARIA_DIA_EXPORT, exportProgramacaoDiariaDia);
}

export default watchProgramacaoDiariaDia;
